import { render } from "./long-insure-detail.vue?vue&type=template&id=6b4c62c6&scoped=true&ts=true"
import script from "./long-insure-detail.vue?vue&type=script&lang=ts"
export * from "./long-insure-detail.vue?vue&type=script&lang=ts"

import "./long-insure-detail.vue?vue&type=style&index=0&id=6b4c62c6&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4c62c6"]])

export default __exports__